const $inject = [];

const sectorGroupsFilter = () => {
  return (paymentMethods, group) => {
    if(group === 'All') {
      return paymentMethods;
    }

    return _.filter(paymentMethods, (paymentMethod) => {
      return paymentMethod.SegmentTypes.indexOf(group) > -1;
    });
  }
};

sectorGroupsFilter.$inject = $inject;

export default sectorGroupsFilter;


// WEBPACK FOOTER //
// ./src/filters/sectorGroupsFilter.js